import { useEffect, useRef, useState } from "react"
import api from "../../api"
import { CountryJson } from "../../static/CountryMaster"
import indiaFlag from '../../static/images/india.png'
const selectionFiels = [
    { displayValue: "Policy No.", value: "policyNo" },
    { displayValue: "Application No.", value: "appNo" },
    { displayValue: "Registration No.", value: "registrationNo" },
]
export default function VerifyOTP({ userToken, setInitialized, OPTVerified, setVerifyied, inputType, setInputType, verifyOTP, setVerifyOTP, maskedMobileNo, setMaskedMobileNo }) {
    const [mobileNumber, setMobileNumber] = useState(null)
    // const [maskedMobileNo, setMaskedMobileNo] = useState(null)
    const [selectedCountry, setSelectCountry] = useState({
        "CountryId": 392,
        "Country": "INDIA",
        "CountryCode": "+91",
        "TIMEZONE": 0,
        "CountryIcon": indiaFlag
    })
    const [errorMessage, setErrorMessage] = useState(null)
    const [countryCodeError, setCountryCodeError] = useState(null)
    // const [verifyOTP, setVerifyOTP] = useState(false)
    const [otpValue, setOtpValue] = useState('');
    const [country, setCountry] = useState(CountryJson)
    const [loading, setLoading] = useState(false)
    const [counterChange, setCountryChange] = useState(false)
    const [verificationSuccess, setOPTVerificationSuccess] = useState(false)
    const inputElement = useRef(null);
    // const [inputType, setInputType] = useState({ displayValue: "Policy No.", value: "policyNo" })

    const Ref = useRef(null);

    // The state for our timer
    const [timer, setTimer] = useState('00:00');
    const [loginWithPolicy, setloginWithPolicy] = useState(false);

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        };
    }

    const startTimer = (e) => {
        let { total, hours, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {

            // update the timer
            // check if less than 10 then we need to
            // add '0' at the beginning of the variable
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
        else {
            setTimer(null)
        }
    }

    const clearTimer = (e) => {

        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next   
        setTimer('00:30');

        // If you try to remove this line the
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();


        deadline.setSeconds(deadline.getSeconds() + 30);
        return deadline;
    }


    const generateOTP = async () => {

        if (!mobileNumber) {
            //setErrorMessage('Enter Mobile No.')
            return
        }
        if (mobileNumber && mobileNumber.length != 10) {
            setErrorMessage('Invalid Mobile No.')
            return
        }
        setLoading(true)
        let payload = {
            mobileNumber: mobileNumber,
            countryCode: selectedCountry.CountryCode,
        }
        await sendOTP(payload)
    }
    const resendOTP = async () => {
        let payload = {
            mobileNumber: mobileNumber,
            countryCode: selectedCountry.CountryCode,
            [inputType.value]: inputType.key
        }
        await sendOTP(payload)
    }
    const submitPolicyNo = async () => {
        if (!inputType.key) {
            setErrorMessage(`Enter ${inputType.displayValue}`)
            return
        }
        let payload = {
            [inputType.value]: inputType.key
        }
        await sendOTP(payload)
    }
    const sendOTP = async (payload) => {
        setLoading(true)
        let res = await api.generateOTPApi(userToken, payload)
        setLoading(false)
        if (res && res.code === 200) {
            setMaskedMobileNo(res.result.maskedMobileNo)
            setVerifyOTP(true);
            setOtpValue([]);
            clearTimer(getDeadTime());
            setErrorMessage('');
            setTimeout(() => {
                inputRefs.current[0]?.focus();
            }, 300);
        }
        else {
            setErrorMessage('Something went wrong')
        }
    }
    const OTPVerification = async () => {
        if (!otpValue || (typeof otpValue) != "object" || otpValue.join("").length < 6) {
            return false;
        }
        setErrorMessage("");
        setLoading(true)
        let payload = {
            mobileNumber: mobileNumber,
            countryCode: parseInt(selectedCountry.CountryCode),
            otp: parseInt(otpValue.join('')),
            [inputType.value]: inputType.key
        }
        setErrorMessage(null)
        let res = await api.verifyOTPApi(userToken, payload)
        setLoading(false)
        if (res && res.code === 200) {
            handleLoginSuccess()
            setOPTVerificationSuccess(true)

            setTimeout(() => {
                setVerifyied(true)
            }, 2000)
        } else if (res && res.code === 500) {
            setErrorMessage(res.message)
        }
        else {
            setErrorMessage('Please Enter Correct OTP')
        }
    }
    const inputRefs = useRef([]);

    useEffect(() => {
        // Focus the first input field on component mount
        inputRefs.current[0]?.focus();
    }, []);

    const handleChange = (index, value) => {
        if (index == 0 && value.length == 6) {
            setOtpValue(value.split(''));
            setTimeout(() => {
                inputRefs.current[5]?.focus()
            }, 400);
            return;
        }
        if (value.length > 1) {
            value = Math.floor(value % 10)
        }
        setOtpValue((prevOtpValue) => {
            // Copy the existing OTP value and update the changed field
            const newOtpValue = [...prevOtpValue];
            newOtpValue[index] = value;
            return newOtpValue;
        });

        if (value !== '' && index < inputRefs.current.length - 1) {
            // Move focus to the next input field if the current field has a value
            inputRefs.current[index + 1]?.focus();
        }
    };
    const searchCountry = (search) => {
        if (search) {
            let list = CountryJson.filter((obj) =>
                obj.Country.toLowerCase().includes(search.toLowerCase().trim()) || obj.CountryCode.toLowerCase().includes(search.toLowerCase().trim())
                    ? true
                    : false
            );
            setCountry(list)
        }
        else {
            setCountry(Object.values(CountryJson))
        }
    }
    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && index > 0 && !otpValue[index]) {
            // Move focus to the previous input field if Backspace is pressed and the current field is empty
            inputRefs.current[index - 1]?.focus();
        }
    };
    const selectCountry = (country) => {
        if (country) {
            setSelectCountry(country)
            setCountryChange(false)
        }
    }
    const changeNumber = () => {
        setVerifyOTP(false)
        setloginWithPolicy(false);
        setMaskedMobileNo(null)
        // if (mobileNumber) {
        // setMobileNumber(mobileNumber);
        // }
    }
    const loginWithPolicyNo = () => {
        setloginWithPolicy(true);
    }
    const handleLoginSuccess = () => {
        console.log("login success to parent window")
      
            // e.preventDefault();
            console.log("minimizing ini");
            if (window && window.parent) {
                console.log("minimizing start");
                window.parent.postMessage({ message: 'login', login: true }, '*');
            } else {
                console.log("minimizing not  start");
            }
        // GAEvent({eventAction:"Chat-Minimizes",eventLabel: "Click-Chat-Minimizes"})
        
    }
    const handlePolicyNo = (value) => {
        setInputType({
            ...inputType,
            ...{
                key: value
            }
        })
    }
    const validateMobile = (e) => {
        e.target.value = (e.target.value).replace(/\D/g, '')
        setMobileNumber(e.target.value);
    }

    return (
        <div class="chatbox-container">
            <div class="step-1">
                {verificationSuccess ?
                    <div class="card ">
                        <div class="verify-icon">

                        </div>
                        <h3 class="no-border textcenter">OTP verified successfully!</h3>
                    </div>
                    :
                    <>
                        {verifyOTP ?
                            < div class="card ">
                                <h3 class="no-border">Please enter 6 digit OTP sent on </h3>
                                {maskedMobileNo ?
                                    <div className="mobile-number">
                                        <h3 class="strong">{maskedMobileNo}</h3>
                                        <span onClick={changeNumber}>Change</span>
                                    </div>
                                    : null}
                                <div class="inputFeildWrapper">
                                    <form>
                                        {errorMessage ?
                                            <span className="error otpError">{errorMessage}</span>
                                            : null}
                                        <ul class="optinput">

                                            {Array.from({ length: 6 }, (_, index) => (
                                                <li>
                                                    <input
                                                        key={index.toString()}
                                                        // type="number"
                                                        autoFocus={index === 0}
                                                        name="otpinput1"
                                                        id="otpinput1"
                                                        className="otp"
                                                        autoComplete="off"
                                                        inputmode="numeric"
                                                        pattern="[0-9]*"
                                                        // tabIndex={1}
                                                        // maxLength={1}
                                                        // max={9}
                                                        value={otpValue[index] || ''}
                                                        onChange={(e) => handleChange(index, e.target.validity.valid ? e.target.value : "")}
                                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                                        ref={(ref) => (inputRefs.current[index] = ref)}
                                                    />
                                                </li>
                                            ))}




                                        </ul>
                                    </form>
                                    <span class="link resend" >
                                        {timer ?
                                            <span >{timer}</span>
                                            :
                                            <span onClick={() => resendOTP()}>Resend OTP</span>
                                        }
                                    </span>
                                </div>
                                <button onClick={() => OTPVerification()} disabled={loading} className={loading ? "button loading" : "button"}>Submit</button>

                            </div>
                            :
                            <>
                                {loginWithPolicy ?
                                    <div class="card">
                                        <h3>Verify your account & get started</h3>


                                        <div class="slide-container">
                                            {selectionFiels.map((item) =>
                                                <label className={`${item.value === inputType.value ? 'active' : ''}`} onClick={() => setInputType(item)}>{item.displayValue}</label>
                                            )}

                                            <a class="slide" aria-hidden="true"></a>
                                        </div>


                                        <div class="registration_check">
                                            <div class="formInput">
                                                <input type="text" 
                                                    class="full labelshow" maxlength="30" value={inputType.key || null} placeholder={inputType.displayValue} onChange={(event) => handlePolicyNo(event.target.value)} />
                                                <label class="feildLable" for="policy-no"></label>
                                            </div>
                                        </div>
                                        {errorMessage ?
                                            <span id="error-sign-in"><img src="https://static.pbcdn.in/myaccount-cdn/images/error.svg" alt="error-img" /> {errorMessage}</span>
                                            : null}
                                        <button className={loading ? "button loading" : "button"} disabled={loading} onClick={() => submitPolicyNo()}>Send OTP</button>
                                        <span class="link">
                                            <span onClick={changeNumber}>Login using Mobile number</span>
                                        </span>
                                    </div>
                                    :
                                    <div class="card">
                                        <h3>Share your registered mobile number</h3>
                                        <div class="registration_check">
                                            <div class="formInput">
                                                <div class="countybox" >
                                                    {selectedCountry ?
                                                        < >
                                                            <div class="country-flag" id="country-ddp" onClick={() => setCountryChange(true)}>
                                                                <img loading="lazy" alt="india" src={selectedCountry.CountryIcon} />
                                                            </div>
                                                            <div class="cCode" id="country-code" >{selectedCountry.CountryCode}</div>
                                                        </>
                                                        : null}
                                                    <ul class={`flags ${counterChange ? 'show' : ''}`} style="width:348px">
                                                        {country.map((item) =>
                                                            <li onClick={() => selectCountry(item)}>
                                                                <span class="country-flag">
                                                                    <img src={item.CountryIcon} />
                                                                </span>
                                                                <div class="cname">{item.Country}</div>
                                                                <div class="code">{item.CountryCode}</div>
                                                            </li>
                                                        )}

                                                    </ul>
                                                </div>
                                                <div class={`search-flag ${counterChange ? 'show' : ''}`}>
                                                    <div class="searchico">
                                                    </div>
                                                    <input type="text" max-length="3" placeholder="Search" onChange={(event) => searchCountry(event.target.value)} />
                                                </div>
                                                <input type="text" data-msg="Enter your mobile number." id="getHelpInput"
                                                    autocomplete="false" inputmode="numeric" value={mobileNumber}
                                                    class="fullWidht getHelpInput getHelpMobNo labelshow" maxlength="10" actual-val=""
                                                    minlength="10" onChange={(e) => validateMobile(e)} placeholder="Mobile No." />
                                                <label class="feildLable mobN" for="termMobile">Registered mobile number</label>
                                            </div>
                                        </div>
                                        {errorMessage ?
                                            <span id="error-sign-in"><img src="https://static.pbcdn.in/myaccount-cdn/images/error.svg" alt="error-img" /> {errorMessage}</span>
                                            : null}
                                        <button className={loading ? "button loading" : "button"} onClick={() => generateOTP()}>Send OTP</button>
                                        <span class="link">
                                            <span onClick={loginWithPolicyNo}>Login using alternate options</span>
                                        </span>
                                    </div>
                                }
                            </>
                        }
                    </>
                }
            </div>
        </div >

    );
}
